import React from 'react';
import FooterDesktop from '../../components/Footer/FooterDesktop/FooterDesktop';
import HeaderBig from '../../components/Header/Big/HeaderBig';
import styles from './About.module.css';
import AboutMain from './Main/AboutMain';

const About = () => {
  return (
    <div className={styles.container}>
      <HeaderBig className={styles.header} />

      <main className={styles.main}>
        <AboutMain />

        <FooterDesktop />
      </main>
    </div>
  );
};

export default About;
